import { Button } from "@/components/ui/button.tsx";
import { ARTIFACT_LIBRARY_CHIPS, type ArtifactLibraryChipId } from "@/types/artifactLibrary.ts";

/**
 * Horizontal, scrollable filter chips for the Artifact Library. The active chip
 * is filled (dark); the rest are outlined. Sourced from `ARTIFACT_LIBRARY_CHIPS`
 * so the row reflects the shared config without per-chip wiring.
 */
export const ArtifactLibraryChips = ({
  activeChipId,
  onSelect,
}: {
  activeChipId: ArtifactLibraryChipId;
  onSelect: (chipId: ArtifactLibraryChipId) => void;
}) => {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
      {ARTIFACT_LIBRARY_CHIPS.map((chip) => (
        <Button
          key={chip.id}
          type="button"
          size="sm"
          variant={chip.id === activeChipId ? "default" : "outline"}
          onClick={() => onSelect(chip.id)}
          data-statsig-name={`artifact-library-chip-${chip.id}`}
          className="shrink-0"
        >
          {chip.label}
        </Button>
      ))}
    </div>
  );
};
